import { useEffect, useState } from 'react';
import { isObject } from '@intelligence/utils/commonUtils';
import { getReportSearchSummaryApi } from '@intelligence/services/reportService';
import type { IReportSearchStats, IReportSearchSummaryResponse } from './types';

export const useReportSearchStats = () => {
  const [stats, setStats] = useState<IReportSearchStats | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getReportSearchSummaryApi()
      .then((res: IReportSearchSummaryResponse) => {
        if (cancelled) return;
        if (isObject(res)) {
          setStats({
            total_reports: Number(res.total_report_count) || 0,
            popular_games: Number(res.popular_games_covered_count) || 0,
            data_sources: Number(res.report_vendor_count) || 0,
            ai_practices: Number(res.game_ai_practices_count) || 0,
          });
        } else {
          setStats(null);
        }
      })
      .catch((err: unknown) => {
        console.error('[ReportSearch] fetch stats failed:', err);
        if (!cancelled) setStats(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { stats, loading };
};
